
import { set, lensPath, equals } from 'ramda';
import * as types from './types';
import { JSON_STRING, HttpClient } from '../../../../services/http/http-client';
import { LabelSettingsService } from '../../services/label-settings.service';
import { MODIFICATION_URL, SETTINGS_URL } from '../../../../services/common-urls';
import { random, generateNextId, isNegative } from '../../../../utility/fp';
import { LABEL_URL } from '../../../accounting/services/costs.service';
import { taskService } from '../../../tasks/services/tasks.service';

// Action Object for LabelSettings. Import the types from label/types.js and Invoke Actions from the Vuex Host Components.

export const taskSettingsActions = {
  async [types.TaskSettingsData.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    commit(types.TaskSettingsData.SET.ALL, {
      label_setting_loading: true,
    });
    // const labelSettingsData = await HttpClient.mergeRequests([

    // ]);


    const external_table = [ 'booking','licence' , 'release' ,'product' , 'general','contract_reminder' ]

    for(let i = 0;i<external_table.length;i++)
    {
      dispatch(types.TaskTypes.FETCH.ALL,{external_table:external_table[i]});
    }

    // commit(types.TaskSettingsData.SET.ALL, {
    //   label_setting_loading: false,
    //   ...taskSettingsData
    // });
  },

  async [types.TaskTypes.FETCH.ALL]({ commit, getters, dispatch }, payload) {
    const { external_table } =payload
    commit(types.TaskSettingsData.SET.ALL, {
      ...getters.taskSettingsData,
      [`${external_table}_task_loading`]: true,
    });
    const licenseSettingsData = await taskService.taskTemplateGroup(external_table)
    console.log(licenseSettingsData,"loading")
    commit(types.TaskSettingsData.SET.ALL, {
      ...getters.taskSettingsData,
      ...licenseSettingsData.data,
      [`${external_table}_task_loading`]: false,
    });
    console.log(getters.taskSettingsData,"loading getters")
  },

}
